module.exports = __webpack_public_path__ + "img/delete.b350b0ed.svg";